export default "__VITE_ASSET__Dp4CS2iy__"